module.exports = __webpack_public_path__ + "img/discover_logo.047a5832.png";